
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MenuItem, Menu, Avatar, Divider } from '@mui/material';
import PropTypes from 'prop-types';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import AddIcon from '@mui/icons-material/Add';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import HomeIcon from '@mui/icons-material/Home';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import SubjectIcon from '@mui/icons-material/Subject';
import RssFeedIcon from '@mui/icons-material/RssFeed';
import MapIcon from '@mui/icons-material/Map';
import { useSelector } from "react-redux";
import { emitCustomEvent } from "react-custom-events";
import Events from "../defaults/Events";

const BlueAlien = "#1976d2";
const AvatarGray = "#bdbdbd";

export default function ActionsMenu({actionClicked, anchorEl, open, handleClose, isUserAdmin, setIsCreateUserOpen, 
  setIsProfileOpen, setServiceValidatorOpen, logout, resetMapView}) {
  const [ myAccountHover, setMyAccountHover ] = useState(false);
  const [ loginHover, setLoginHover ] = useState(false);
  const [ adminUsersHover, setAdminUsersHover] = useState(false);
  const [adminPageHover,setAdminPageHover] = useState(false);
  const [adminOverrideHover,setAdminOverrideHover] = useState(false);
  const [ tipsHover, setTipsHover] = useState(false);
  const [ userGuideHover, setUserGuideHover] = useState(false);
  const [ hubPageHover, setHubPageHover] = useState(false);
  const [ nifcAgolHover, setNifcAgolHover] = useState(false);
  const [serviceValidatorHover,setServiceValidatorHover] = useState(false);
  const [resetMapViewHover,setResetMapViewHover] = useState(false);
  const config = useSelector((state) => state.configuration.config);
  const navigate = useNavigate();


    const handleLogout = () => {
        actionClicked();
        logout();
    };

    const handleAdminCreateUsers = () => {
      setIsCreateUserOpen(true);
      actionClicked();
    }

    const handleAdminPage = () => {
      navigate("/admin");
      actionClicked();
    }

    const handleAdminOverridesPage = () => {
      navigate("/admin/overrides");
      actionClicked();
    }

    const handleProfile = () => {
      setIsProfileOpen(true);
      actionClicked();
    }

    const handleServiceValidator = () => {
      setServiceValidatorOpen(true);
      actionClicked();
    }

    const handleResetMapView = () => {
      emitCustomEvent(Events.ResetMapView);
      actionClicked();
    }

    return (
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
              'aria-labelledby': 'basic-button'
        }}>
            <MenuItem 
              onClick={handleProfile}
              onMouseEnter={() => {
                setMyAccountHover(true);
              }}
              onMouseLeave={() => {
                setMyAccountHover(false);
              }}
            >
              <Avatar sx={{ width: 32, height: 32, margin: '0 10px 0 0', padding: 0, backgroundColor: myAccountHover ? BlueAlien : AvatarGray }} /> My Account
            </MenuItem>
            <Divider variant="middle" />
            <MenuItem 
              onClick={handleLogout}
              onMouseEnter={() => {
                setLoginHover(true);
              }}
              onMouseLeave={() => {
                setLoginHover(false);
              }}
            >
              <Avatar sx={{ width: 32, height: 32, margin: '0 10px 0 0', padding: 0, backgroundColor: loginHover ? BlueAlien : AvatarGray }}>
                <ExitToAppIcon />
              </Avatar>
              Logout
            </MenuItem>
            {(isUserAdmin) &&
                <>
                  <Divider variant="middle" />
                  <MenuItem
                    onClick={handleAdminCreateUsers}
                    onMouseEnter={() => {
                      setAdminUsersHover(true);
                    }}
                    onMouseLeave={() => {
                      setAdminUsersHover(false);
                    }}
                  >
                    <Avatar sx={{ width: 32, height: 32, margin: '0 10px 0 0', padding: 0, backgroundColor: adminUsersHover ? BlueAlien : AvatarGray }}><AddIcon /></Avatar> Admin
                  </MenuItem>
                  <Divider variant="middle" />
                  <MenuItem
                    onClick={handleAdminPage}
                    onMouseEnter={() => {
                      setAdminPageHover(true);
                    }}
                    onMouseLeave={() => {
                      setAdminPageHover(false);
                    }}
                  >
                    <Avatar sx={{ width: 32, height: 32, margin: '0 10px 0 0', padding: 0, backgroundColor: adminPageHover ? BlueAlien : AvatarGray }}><AddIcon /></Avatar> User Admin Grid
                  </MenuItem>
                  <Divider variant="middle" />
                   <MenuItem
                    onClick={handleAdminOverridesPage}
                    onMouseEnter={() => {
                      setAdminOverrideHover(true);
                    }}
                    onMouseLeave={() => {
                      setAdminOverrideHover(false);
                    }}
                  >
                    <Avatar sx={{ width: 32, height: 32, margin: '0 10px 0 0', padding: 0, backgroundColor: adminOverrideHover ? BlueAlien : AvatarGray }}><AltRouteIcon /></Avatar> Admin Overrides
                  </MenuItem>
              </>
            }
            <Divider variant="middle" />
            <MenuItem 
                href="https://inform-fuels-nifc.hub.arcgis.com/pages/faqs"
                target="_blank"
                component="a"
                onClick={actionClicked}
                onMouseEnter={() => {
                  setTipsHover(true);
                }}
                onMouseLeave={() => {
                  setTipsHover(false);
                }}
              >
                <Avatar sx={{ width: 32, height: 32, margin: '0 10px 0 0', padding: 0, backgroundColor: tipsHover ? BlueAlien : AvatarGray }}><QuestionMarkIcon /></Avatar> FAQ/Tips
              </MenuItem>
              <Divider variant="middle" />
              <MenuItem 
                href={`${config.userGuide[config.env].url}`}
                target="_blank"
                component="a"
                onClick={actionClicked}
                onMouseEnter={() => {
                  setUserGuideHover(true);
                }}
                onMouseLeave={() => {
                  setUserGuideHover(false);
                }}
              >
                <Avatar sx={{ width: 32, height: 32, margin: '0 10px 0 0', padding: 0, backgroundColor: userGuideHover ? BlueAlien : AvatarGray }}><SubjectIcon /></Avatar> User Guide
              </MenuItem>
              <Divider variant="middle" />
              <MenuItem 
                href="https://inform-fuels-nifc.hub.arcgis.com/"
                target="_blank"
                component="a"
                onClick={actionClicked}
                onMouseEnter={() => {
                  setHubPageHover(true);
                }}
                onMouseLeave={() => {
                  setHubPageHover(false);
                }}
              >
                <Avatar sx={{ width: 32, height: 32, margin: '0 10px 0 0', padding: 0, backgroundColor: hubPageHover ? BlueAlien : AvatarGray }}><HomeIcon /></Avatar> HubPage
              </MenuItem>
              <Divider variant="middle" />
              <MenuItem 
                href="https://nifc.maps.arcgis.com/home/index.html"
                target="_blank"
                component="a"
                onClick={actionClicked}
                onMouseEnter={() => {
                  setNifcAgolHover(true);
                }}
                onMouseLeave={() => {
                  setNifcAgolHover(false);
                }}
              >
                <Avatar sx={{ width: 32, height: 32, margin: '0 10px 0 0', padding: 0, backgroundColor: nifcAgolHover ? BlueAlien : AvatarGray }}><LocalFireDepartmentIcon /></Avatar> NIFC AGOL
              </MenuItem>
              <Divider variant="middle" />
              <MenuItem 
                onClick={handleServiceValidator}
                onMouseEnter={() => {
                  setServiceValidatorHover(true);
                }}
                onMouseLeave={() => {
                  setServiceValidatorHover(false);
                }}
              >
                <Avatar sx={{ width: 32, height: 32, margin: '0 10px 0 0', padding: 0, backgroundColor: serviceValidatorHover ? BlueAlien : AvatarGray }}><RssFeedIcon /></Avatar> Validate InForm Fuels Services
              </MenuItem>
              <Divider variant="middle" />
              <MenuItem 
                onClick={() => {
                  setResetMapViewHover(false);
                  handleResetMapView();
                }
                }
                onMouseEnter={() => {
                  setResetMapViewHover(true);
                }}
                onMouseLeave={() => {
                  setResetMapViewHover(false);
                }}
              >
                <Avatar sx={{ width: 32, height: 32, margin: '0 10px 0 0', padding: 0, backgroundColor: resetMapViewHover ? BlueAlien : AvatarGray }}><MapIcon /></Avatar> Reset Map View
              </MenuItem>
        </Menu>
    )
}

ActionsMenu.propTypes = {
  actionClicked: PropTypes.func.isRequired, 
  anchorEl: PropTypes.any, 
  open: PropTypes.bool.isRequired, 
  handleClose: PropTypes.func.isRequired,
  isUserAdmin: PropTypes.bool.isRequired,
  setIsCreateUserOpen: PropTypes.func,
  setIsProfileOpen: PropTypes.func,
  logout: PropTypes.func.isRequired
}





